import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Toolbar,
  CircularProgress,
  Tooltip,
  TooltipProps,
  styled,
  tooltipClasses,
  Box,
  TableSortLabel,
} from "@mui/material";
import ApprovalDrawer from "./ApprovalDrawer";
import { useLocation, useNavigate } from "react-router-dom";

import rejectedicon from "../../../src/assests/images/Reassign.svg";

import { getTasksToApprove, reassigntask } from "./apis";
import { getToken } from "../../utils/utils";
import { format } from "date-fns";
import RejectorDrawer from "./RejectorDrawer";
import SortingArrow from "../../../src/assests/images/Sorting.svg";
import { useAlert } from "../../pages/AlertContext/AlertContext";

type Task = {
  action: any;
  id: null | undefined;
  pmi_entity_code: string;
  task_en: string;
  approval_status?: string; // Add this to track the status
};

type Column = {
  field: string;
  headerName: string;
  type?: string | "action";
};

type DataTableProps = {
  columns: Column[];
  rows: any[];
  onActionClick: (row: any) => void;
  loading: boolean;
  drawerData?: any;
  selectedLocation?: string[];
  SelectedTaskId?: string[];
  debouncedSearchTerm?: string;
  pageindex?: string;
  limit?: string;
  value11: number;
  finaldata22: any;
};

const DataTable: React.FC<DataTableProps> = ({
  columns,
  rows,
  onActionClick,
  loading,
  drawerData,
  selectedLocation,
  SelectedTaskId,
  debouncedSearchTerm,
  pageindex,
  limit,
  value11,
  finaldata22,
}) => {
  const [selectedTabId, setSelectedTabId] = useState<number | null>(null);
  const [reassignedTasks, setReassignedTasks] = useState<Set<string>>(new Set()); // Track reassigned tasks
  const location = useLocation();
  const { showAlert } = useAlert();
  console.log(SelectedTaskId, "SelectedTaskIdSelectedTaskId444444444")
  const navigate = useNavigate();
  //  const [orderBy, setOrderBy] = useState<keyof DataTableProps | "">("");
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<string>("");
  const tokenn = getToken();

  const [totals, setTotals] = useState({
    in_progress: 0,
    rejected: 0,
    approved: 0,
    verified_by_pmi: 0,
  });

  console.log(value11, "value11value11value11222");
  useEffect(() => {
    if (location.state?.valuetabsdata) {
      setSelectedTabId(location.state.valuetabsdata);
    }
  }, [location.state]);

  console.log("Selected Rows: ", rows);

  const [tasksData, settasksData] = useState<Task[]>([]);

  // Function to check if a task can be reassigned
  const canReassignTask = (row: any) => {
    // Check if task is already reassigned (status is pending) or if it's in the reassigned tasks set
    const isPending = row.approval_status?.toLowerCase() === 'pending';
    const isAlreadyReassigned = reassignedTasks.has(row.id);

    return !isPending && !isAlreadyReassigned;
  };

  const handleRejectClick = async (rowId: string) => {
    // Check if task can be reassigned before proceeding
    const row = rows.find(r => r.id === rowId);
    if (!canReassignTask(row)) {
      alert("This task has already been reassigned or is pending.");
      return;
    }

    console.log(`Task ${rowId} Rejected Success`);

    // Add to reassigned tasks immediately to prevent double-clicking
    setReassignedTasks(prev => new Set(prev).add(rowId));

    const fetchData = async () => {
      const reqBody: { publish_id: string } = {
        publish_id: rowId,
      };

      try {
        const response = await reassigntask(reqBody, tokenn);
        if (response) {
          console.log("Task reassigned successfully:", response);
          // alert(`Task ${rowId} Reassign Success`);
          showAlert(`${response.data.data.task_id} id's Task Successfully Reassigned`, "success");

        }
      } catch (error) {
        console.error("Error while reassigning task:", error);
        // Remove from reassigned tasks if there was an error
        setReassignedTasks(prev => {
          const newSet = new Set(prev);
          newSet.delete(rowId);
          return newSet;
        });
        return;
      }
    };

    await fetchData();

    const queryParams = {
      status: "rejected",
      location: selectedLocation || [],
      task_id: SelectedTaskId || [],
      search: debouncedSearchTerm || "",
      page: pageindex || "",
      limit: limit || "",
    };

    try {
      const res = await getTasksToApprove(
        tokenn,
        queryParams.status,
        queryParams.search,
        queryParams.page,
        queryParams.limit,
        queryParams.location,
        queryParams.task_id
      );

      if (res.status) {
        const filteredData =
          res.data?.data?.map((item: any) => ({
            id: item.id,
            pmi_entity_code: item.pmi_entity_code || "",
            task_en: item["task.task_en"] || "",
            task_type_en: item["task.task_type_en"] || "",
            outlet_name: item.outlet_name || "",
            approval_status: item.approval_status || "",
            remarks: item.remarks || "",
            locations: item.locations,
            reassign_account_length: item.reassign_account_length,
            verified_by_pmi: item.verified_by_pmi,
            updated_at: item.updated_at
              ? format(new Date(item.updated_at), "dd MMM yyyy")
              : "",
            action: item,
          })) || [];
        settasksData(filteredData);

        setTotals(
          res.data?.totals || {
            in_progress: 0,
            rejected: 0,
            approved: 0,
            verified_by_pmi: 0,
          }
        );
        console.log("Tasks fetched successfully:", res);
      }
    } catch (error) {
      console.error("Error while fetching tasks to approve:", error);
    }
  };

  if (tasksData.length) {
    rows = tasksData;
  }

  console.log(value11, "value11value11value11");
  let totalcount1 = 0;

  if (value11 === 0) {
    totalcount1 = totals.in_progress;
  } else if (value11 === 1) {
    totalcount1 = totals.rejected;
  } else if (value11 === 2) {
    totalcount1 = totals.approved;
  } else if (value11 === 3) {
    totalcount1 = totals.verified_by_pmi;
  }

  useEffect(() => {
    if (totalcount1 == 0 || totalcount1 >= 0) {
      navigate(`/tasks-approval`, { state: { totalcount122a: totals } });
    }
  }, [totalcount1]);

  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#282829",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#282829",
      color: "#fff",
      fontSize: "12px",
      fontWeight: "400",
      padding: "6px 12px",
    },
  }));
  const sortedRows = [...rows].sort((a, b) => {
    if (!orderBy) return 0;

    const aVal = a[orderBy];
    const bVal = b[orderBy];

    if (aVal == null || bVal == null) return 0;

    if (typeof aVal === "string" && typeof bVal === "string") {
      return order === "asc" ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
    }

    if (typeof aVal === "number" && typeof bVal === "number") {
      return order === "asc" ? aVal - bVal : bVal - aVal;
    }

    return 0;
  });

  const handleSort = (property: string) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  return (
    <Paper
      sx={{
        boxShadow: "none",
        padding: "0 32px",
        backgroundColor: "#F9FBFC",
      }}
    >
      <Toolbar
        sx={{ paddingLeft: "0 !important", minHeight: "unset !important" }}
      ></Toolbar>
      <TableContainer
        className="task-approval-table-tabs"
        sx={{
          border: "1px solid rgb(150, 150, 150)",
          borderRadius: "8px",
          marginTop: "50px",
          boxShadow: "-1px 1px 1px #e7e8e9"
        }}
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "20px",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <Table sx={{}}>
            <TableHead sx={{ background: "rgba(238, 244, 255, 1)" }}>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.field}
                    sx={{ padding: "16px 10px !important" }}
                  >
                    {column.field === "action" ? (
                      column.headerName
                    ) : (
                      <TableSortLabel
                        active={orderBy === column.field}
                        direction={orderBy === column.field ? order : "asc"}
                        onClick={() => handleSort(column.field as keyof DataTableProps)}

                        IconComponent={() => (
                          <img
                            src={SortingArrow}
                            alt="Sort Icon"
                            style={{ width: 18, height: 18, marginLeft: 4 }}
                          />
                        )}
                        sx={{
                          "& .MuiTableSortLabel-icon": {
                            opacity: 1,
                          },
                        }}
                      >
                        {column.headerName}
                      </TableSortLabel>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedRows.map((row) => (
                <TableRow key={row.id}>
                  {columns.map((column) => (
                    <TableCell
                      sx={{
                        padding: "16px 10px !important",
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '150px'
                      }}
                      key={column.field}
                    >
                      {/* {console.log("Column Type:", column.type)} */}
                      {column.type === "action" ? (
                        <ApprovalDrawer
                          SideDrawer={drawerData}
                          rows={row[column.field]}
                          datayaya={rows}
                          value112={value11}
                          finaldata22={finaldata22}
                          selectedLocation={selectedLocation}
                          SelectedTaskId={SelectedTaskId}
                          debouncedSearchTerm={debouncedSearchTerm}
                          pageindex={pageindex}
                          limit={limit}
                        />
                      ) : column.type === "Rejected Icon" ? (
                        <BootstrapTooltip
                          title={canReassignTask(row) ? "Reassign Task" : "Task already reassigned"}
                        >
                          <Box sx={{ display: "flex" }}>
                            <img
                              src={rejectedicon}
                              alt="Rejected Icon"
                              style={{
                                cursor: canReassignTask(row) ? "pointer" : "not-allowed",
                                opacity: canReassignTask(row) ? 1 : 0.5,
                                filter: canReassignTask(row) ? "none" : "grayscale(100%)"
                              }}
                              onClick={() => {
                                if (canReassignTask(row)) {
                                  handleRejectClick(row.id);
                                }
                              }}
                            />
                            <RejectorDrawer
                              SideDrawer={drawerData}
                              rows={row[column.field as keyof Task]}
                              datayaya={rows}
                              value112={value11}
                              finaldata22={finaldata22}
                              selectedLocation={selectedLocation}
                              SelectedTaskId={SelectedTaskId}
                              debouncedSearchTerm={debouncedSearchTerm}
                              pageindex={pageindex}
                              limit={limit}
                            />
                          </Box>
                        </BootstrapTooltip>
                      ) : (
                        // row[column.field]
                        column.field === "remarks" ? (
                          <Tooltip
                            title={row[column.field] || ""}
                            arrow
                            placement="top"
                            PopperProps={{
                              modifiers: [
                                {
                                  name: "offset",
                                  options: { offset: [0, 8] },
                                },
                              ],
                            }}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  maxWidth: 300,
                                  whiteSpace: "normal",
                                  fontSize: "13px",
                                },
                              },
                            }}
                          >
                            <span
                              style={{
                                display: "inline-block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "140px",
                              }}
                            >
                              {(row[column.field] || "").length > 50
                                ? `${row[column.field].slice(0, 50)}...`
                                : row[column.field]}
                            </span>
                          </Tooltip>
                        ) : (
                          row[column.field]
                        )



                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </Paper>
  );
};

export default DataTable;